import React, { Component } from "react";
import classNames from "classnames";
import "../icon/Icon.css";


type Callback = (event:any) => void;

interface IconProps {
  /** icon's name */
  name: string;
  id?: string;
  /** the height of the icon in pixels eg:  height="10" */
  height?: string;
  /** the width of the icon in pixels eg:  width="10" */
  width?: string;
  /** space in pixels on the left of the icon eg: marginLeft="20" **/
  marginLeft?: string;
  /** space in pixels on the right of the icon eg: marginRight="20" **/
  marginRight?: string;
  /** space in pixels on the top of the icon eg: marginTop="20" **/
  marginTop?: string;
  /** space in pixels on the bottom of the icon eg: marginBottom="20" **/
  marginBottom?: string;
  /** The icon's click callback function if the icon is actionable */
  clickHandler?: Callback;
  /** Custom CSS class */
  className?: string;
  color?: string;
  /** alternate text for the image.  Used by screen readers */
  alt?: string;
}

export default function Icon(props: IconProps) {
  function handleClick(e: any) {
    const { clickHandler } = props;

    if (clickHandler) {
      clickHandler(e);
    }
  }

  const {
    name,
    height,
    width,
    id,
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    color,
    alt,
  } = props;
  const className = props.className || "";
  let inlineStyles: { [key: string]: any } = {};

  if (height) {
    inlineStyles.height = `${height}px`;
  }

  if (width) {
    inlineStyles.width = `${width}px`;
  }

  if (marginLeft) {
    inlineStyles.marginLeft = `${marginLeft}px`;
  }

  if (marginRight) {
    inlineStyles.marginRight = `${marginRight}px`;
  }

  if (marginTop) {
    inlineStyles.marginTop = `${marginTop}px`;
  }

  if (marginBottom) {
    inlineStyles.marginBottom = `${marginBottom}px`;
  }

  return (
    <img
      src={require(`../../assets/icons/${name}.svg`)}
      style={inlineStyles}
      className={classNames("mtm-icon", className)}
      onClick={handleClick}
      id={id}
      alt={alt || ""}
    />
  );
}
